import { Factor, FactorKey } from "types/factor/factor";

export type ParsedFactorMap = Partial<Record<FactorKey, Factor>>;

export const FACTOR_ORDER = [
  FactorKey.WebAuthn,
  FactorKey.GoogleAuth,
  FactorKey.OktaVerify,
  FactorKey.Sms,
  FactorKey.Call,
];

export type ParsedFactorData = {
  factorMap: ParsedFactorMap;
  factorOrder: FactorKey[];
};
